import styles from "./styles/subtype-button.module.scss";
import React from "react";
import TabButton from "@/components/common/tab-button";

export type SubType = "MONTHLY" | "YEARLY";

interface SubtypeButtonProps {
  type: SubType;
  selectedSubtype: SubType;
  setSubtype: (type: SubType) => void;
}

const SubtypeButton = ({
  type,
  selectedSubtype,
  setSubtype,
}: SubtypeButtonProps) => {
  return (
    <TabButton
      type={type}
      selectedSubtype={selectedSubtype}
      setSubtype={setSubtype}
      overriddenNotSelected={styles.not_selected}
    >
      {type === "MONTHLY" ? (
        type.toLowerCase()
      ) : (
        <div className={styles.yearly_content}>
          {`${type.toLowerCase()} (40% OFF)`}
        </div>
      )}
    </TabButton>
  );
};

export default SubtypeButton;
